import { getEditTranslationsPrivilege } from '@skytech/utils'

import type { TokenData } from '@/app/types'

const getUserFromToken = (tokenData: TokenData) => {
  const user = {
    id: tokenData.uid,
    whiteLabelId: tokenData.wlid,
    costObjectId: tokenData.coid,
    customerId: tokenData.cid,
    mayApproveOwnApplications: tokenData.iom,
    customerHeadId: tokenData.chid,
    role: tokenData.role,
    editTranslationsPrivilege: getEditTranslationsPrivilege(tokenData.ia),
  }

  return user
}

export default getUserFromToken
